import React from 'react';
import safeJsonValue from 'safe-json-value';
import { Modal, ModalCloseButton, ModalContent, ModalTrigger } from '../modal';
import Typography from '../typography';

type PropsBrowserProps = Record<string, unknown>;

const PropsBrowser: React.FC<PropsBrowserProps> = props => (
    <Modal>
        <ModalTrigger>
            View Props
        </ModalTrigger>
        <ModalContent css={{ maxWidth: '80vw', maxHeight: 'unset' }}>
            <ModalCloseButton />
            <Typography fontSize="2xl" fontWeight="medium">
                Properties
            </Typography>
            <div style={{ fontFamily: 'monospace', fontSize: '14px', margin: '1em 0' }}>
                <pre
                    style={{
                        backgroundColor: '#f9f9f9',
                        border: '1px solid #eee',
                        padding: '1em',
                        marginTop: '0.5em',
                        overflowX: 'auto',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                    }}
                >
                    {(() => {
                        const { value } = safeJsonValue(props);
                        return JSON.stringify(value, null, 2);
                    })()}
                </pre>
            </div>
        </ModalContent>
    </Modal>
);

export default PropsBrowser;
